import { useEffect, useRef, useState } from "react";
import Button from "../UI/Button";
import { useDispatch } from "react-redux";
import { RootState } from "../../redux/type";
import { sendBanner, sendMessage } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const firebaseData = firebase.firestore().collection("messages");
var storageRef = firebase.storage().ref();

export default function AddBanner() {
  const [files, setFiles] = useState("");
  const [success, setSuccess] = useState(""); // to display message if the message is sent or not
  const [error, setError] = useState("");
  const [existingBanners, setExistingBanners] = useState<any[]>([]); // For displaying banners from Firestore
  const [selectedBanners, setSelectedBanners] = useState<any[]>([]);; // Track selected images
  const fileInputRef = useRef<HTMLInputElement>(null); // Create a ref for the file input

  const dispatch = useDispatch();

  const fetchbannerData = async () => {
    try {
      const db = firebase.firestore();

      const bannerDoc = await db.collection('Game_Config').doc("AdvertisementData").get()
      const bannerData = bannerDoc.data()
      console.log("fetchbannerData data", bannerData)

      const extractValidUrls = (data: any) => {
        // Extract values and filter out empty strings or falsy values
        return Object.values(data).filter((url) => !!url);
      };

      const validUrls = extractValidUrls(bannerData);
      setExistingBanners([...validUrls])
      console.log("validUrls data", validUrls)
      console.log("existingBanners data", existingBanners)


    } catch (error) {
      console.error("Error fetching document: ", error);
    }
  };
  useEffect(() => {
    fetchbannerData();
  }, []);

  useEffect(() => {
    console.log("selectedBanners updated in useeffect", selectedBanners);
  }, [selectedBanners]);

  const handleCheckboxChange = (url: string) => {
    console.log("handleCheckboxChange clicked")
    setSelectedBanners((prevSelectedBanners) =>
      prevSelectedBanners.includes(url)
        ? prevSelectedBanners.filter((image) => image !== url)
        : [...prevSelectedBanners, url]
    );
    console.log("selectedBanners clicked", selectedBanners)

  };

  const saveMessage = async (e: any) => {
    e.preventDefault();
    const { file } = e.target;

    const filesToUpload = file.files;
    let validationErrorsOfImage: boolean = false;

    try {
      // Upload files to Firebase Storage
      const uploadPromises = Array.from(filesToUpload).map(async (fileToUpload: any, index: number) => {
        // const fileRef = storageRef.child(`banner/${fileToUpload.name}`);
        const fileRef = storageRef.child(`banner/bannerads${index + 1}`);

        await uploadBytes(fileRef, fileToUpload);
        const fileUrl = await getDownloadURL(fileRef);
        return fileUrl;
      });

      // Wait for all file uploads to complete and get URLs
      const uploadedFileUrls = await Promise.all(uploadPromises);
      console.log("Uploaded file URLs:", uploadedFileUrls);

      // Update state after all file uploads are done
      console.log("setfilesdata", uploadedFileUrls)
      // Dispatch the action only after all files are uploaded
      if ((uploadedFileUrls.length < 1 || filesToUpload.length > 8) && selectedBanners.length == 0) {
        setError("Please select 1 to 8 images only");
        setSuccess("")
        return;
      }

      await Promise.all(uploadedFileUrls.map(async (fileUrl) => {
        return new Promise<void>((resolve) => {
          const img = new Image();
          img.src = fileUrl;

          img.onload = () => {
            const { width, height } = img;

            if (width !== 1024 || height !== 1024) {
              validationErrorsOfImage = true;
            }
            resolve();
          };
        });
      }));

      if (validationErrorsOfImage) {
        setError("Images dimension are invalid, check again. Use 1024x1024 images to avoid error");
        setSuccess("");
        return;
      } else {

        setExistingBanners((prevBanners) => [...uploadedFileUrls]);
        setSelectedBanners((prevBanners) => [...prevBanners, ...uploadedFileUrls]);

        console.log("uploadedFileUrls", uploadedFileUrls)
        console.log("uploadedFileUrls", uploadedFileUrls.length)
        console.log("existingBanners", existingBanners)
        console.log("existingBanners", existingBanners.length)

        console.log("selectedBanners", selectedBanners)
        console.log("selectedBanners", selectedBanners.length)


        // Check for validation errors
        dispatch(sendBanner([...selectedBanners, ...uploadedFileUrls]));

        setError("")
        setSuccess("All banners uploaded successfully!");
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clear the file input
        }
      }
      fetchbannerData()
      setSelectedBanners([])


    } catch (err) {
      console.error("Error uploading files:", err);
      setError("Failed to upload files. Please try again.");
      setSuccess("");

    }
  };

  return (
    <main>
      <div className="container-fluid px-4">
        <div>
          <h1>Add Banners</h1>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={saveMessage}>


              <div className="form-row">
                <input
                  type="file"
                  className="form-control"
                  id=""
                  name="file"
                  multiple
                  ref={fileInputRef} // Assign ref to the input

                />
              </div>




              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}

              <Button text="Submit Banner" className="btn btn-primary btn-lg" />
              <p style={{ padding: "5px" }}> <b>NOTE:</b> If you want to retain the current banners along with the new banners, select them using checkbox and submit. Image Dimension should be 1024x1024. </p>
            </form>
          </div>
        </div>
        <div className="row py-1">
          <h3>Current Banners</h3>
          <div className="banner-images" style={{ display: "flex", flexWrap: "wrap", overflowY: "auto", maxHeight: "auto" }}>
            {existingBanners.length > 0 ? (
              existingBanners.map((url, index) => (
                <div>
                  <img
                    key={index}
                    src={url}
                    alt={`Banner ${index}`}
                    style={{ width: "150px", height: "150px", margin: "10px", objectFit: "cover" }}
                  />
                  <input
                    type="checkbox"
                    checked={selectedBanners.includes(url)}
                    onChange={() => handleCheckboxChange(url)}
                    style={{ margin: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}
                  />
                </div>
              ))
            ) : null}
          </div>
        </div>

      </div>
    </main>
  );
}